import React, { useMemo } from "react";

interface Props {
  currentBalance: number
  amount: number
  adjustmentType: "INCREASE" | "DECREASE" | ""
}

const CashAdjustmentPreview: React.FC<Props> = ({
  currentBalance,
  amount,
  adjustmentType
}) => {

  const result = useMemo(() => {

    if (!amount) return currentBalance

    if (adjustmentType === "DECREASE") {
      return currentBalance - amount
    }

    if (adjustmentType === "INCREASE") {
      return currentBalance + amount
    }

    return currentBalance

  }, [currentBalance, amount, adjustmentType])

  const adjustmentValue =
    adjustmentType === "DECREASE"
      ? -amount
      : adjustmentType === "INCREASE"
      ? amount
      : 0

  const adjustmentColor =
    adjustmentType === "DECREASE"
      ? "bg-danger text-white"
      : "bg-success text-white"

  return (

    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">

      {/* Header */}
      <div className="border-b border-stroke px-4 py-3 dark:border-strokedark">
        <h3 className="font-medium text-black dark:text-white">
          Impacto del ajuste
        </h3>
      </div>

      {/* Body */}
      <div className="p-5">

        <div className="grid grid-cols-3 gap-4 text-center">

          {/* Saldo actual */}
          <div>
            <p className="text-sm text-gray-500">Saldo actual</p>

            <p className="mt-1 text-lg font-semibold text-black dark:text-white">
              ${currentBalance.toFixed(2)}
            </p>
          </div>

          {/* Ajuste */}
          <div>
            <p className="text-sm text-gray-500">Ajuste</p>

            <span
              className={`inline-flex mt-1 rounded px-3 py-1 text-sm font-medium ${adjustmentColor}`}
            >
              {adjustmentValue >= 0 ? "+" : ""}
              ${adjustmentValue.toFixed(2)}
            </span>
          </div>

          {/* Resultado */}
          <div>
            <p className="text-sm text-gray-500">Saldo resultante</p>

            <p className="mt-1 text-xl font-bold text-primary">
              ${result.toFixed(2)}
            </p>
          </div>

        </div>

      </div>

    </div>

  )

}

export default CashAdjustmentPreview